import { render, staticRenderFns } from "./PieChartB2BB2C.vue?vue&type=template&id=d940d898&scoped=true&lang=pug&"
import script from "./PieChartB2BB2C.vue?vue&type=script&lang=ts&"
export * from "./PieChartB2BB2C.vue?vue&type=script&lang=ts&"
import style0 from "./PieChartB2BB2C.vue?vue&type=style&index=0&id=d940d898&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d940d898",
  null
  
)

export default component.exports